<template>
    <div class="search">
        <i class="searchIcon i-sm i-search"></i>
        <b-form-input v-model="search" placeholder="Wyszukaj..."></b-form-input>
        <div class="searchResult">
            <div class="searchLoader" v-if="loader">
                <div class="span">
                    <div class="help"></div>
                </div>
            </div>
            <div v-else class="dataResult">
                <b-dropdown-header><i class="icons i-sm i-strategy"></i>
                    <p>Ćwiczenia</p>
                    <div class="resultsCount">{{searchList.trainings.length}} łącznie</div>
                </b-dropdown-header>
                <b-dropdown-divider></b-dropdown-divider>
                <div class="titles" v-for="training in searchList.trainings">
                    {{training.title}}
                </div>
                <div class="center" v-if="searchList.trainings.length === 0">
                    <i class="i-sm i-empty-set"></i>
                </div>
                <b-dropdown-header><i class="icons i-sm i-form"></i>
                    <p>Konspekty</p>
                    <div class="resultsCount">{{searchList.conspects.length}} łącznie</div>
                </b-dropdown-header>
                <b-dropdown-divider></b-dropdown-divider>
                <div class="titles" v-for="conspect in searchList.conspects">
                    {{conspect.title}}
                </div>
                <div class="center" v-if="searchList.conspects.length === 0">
                    <i class="i-sm i-empty-set"></i>
                </div>
                <b-dropdown-header><i class="icons i-sm i-calendar"></i>
                    <p>Kalendarz</p>
                    <div class="resultsCount">{{searchList.dates.length}} łącznie</div>
                </b-dropdown-header>
                <b-dropdown-divider></b-dropdown-divider>
                <div class="calendar" v-for="date in searchList.dates">
                    <div class="calendarDate">{{date.date}}</div>
                    {{date.description}}
                </div>
                <div class="center" v-if="searchList.dates.length === 0">
                    <i class="i-sm i-empty-set"></i>
                </div>
                <b-dropdown-header><i class="icons i-sm i-multi-users"></i>
                    <p>Znajomi</p>
                    <div class="resultsCount">{{searchList.friends.length}} łącznie</div>
                </b-dropdown-header>
                <b-dropdown-divider></b-dropdown-divider>
                <div class="userRender" v-for="friend in searchList.friends">
                    <div v-if="friend.avatar.length !== 0"><img :src="friend.avatar"></div>
                    <div v-else><i class="i-user"></i></div>
                    {{friend.name}}
                </div>
                <div class="center" v-if="searchList.friends.length === 0">
                    <i class="i-sm i-empty-set"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        data: () => (
            {
                searchList:
                    {
                        trainings: [
                            {
                                id: 1,
                                title: "Pompki",
                            },
                            {
                                id: 2,
                                title: "Biegi",
                            },
                            {
                                id: 3,
                                title: "Rzuty karne",
                            },
                        ],
                        conspects: [

                        ],
                        dates: [
                            {
                                id: 1,
                                date: "24 marca 2018",
                                description: "Testy szybkościowe"
                            }
                        ],
                        friends: [
                            {
                                id: 1,
                                name: "Tomasz Kowalski",
                                avatar: ""
                            }
                        ],
                    },
                search: '',
                loader: true
            }
        ),
        methods: {

            searchFilter(val) {
                if (val.length <= 3) {
                    this.loader = true;
                    axios.post('/', {})
                        .then((respond) => {
                            this.searchList = respond.data;
                            this.loader = false;
                        })
                        .catch((respond) => {
                        this.loader = false;
                    });
                }
            }
        },
        watch: {
            search: function (val) {
                this.searchFilter(val);
            }
        }
    }
</script>
